module.exports = __webpack_public_path__ + "static/media/furness_bs.b761322e.jpg";